module.exports = __webpack_public_path__ + "media/images/logo_white-ffcf79c0d7d98e3197190a197d6d97d6.svg";